export const isValidZipCode = (zip: string) => /^\d{5}(-\d{4})?$/.test(zip);
export const isValidPhoneNumber = (phone: string) => /^[0-9+() -.]+$/.test(phone);
export const isValidEmail = (email: string) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
